import React from 'react'
import styled, { keyframes } from 'styled-components'
import PropTypes from 'prop-types'

const containerColor = props => props.color

const coloredFlex = props => {
  const { color, ...otherProps } = props
  return (
    <div className="flex" {...otherProps}>
      {props.children}
    </div>
  )
}

const CustomizedFlex = styled(coloredFlex)`
  position: relative;
  background-color: ${containerColor};
`

const ItemsFlex = styled.div`
  display: flex;
  flex: 1;
  z-index: 0;
`

const progressAnimation = keyframes`
  0% { background-position: -160px 0; }
  100% { background-position: calc(160px + 100%) 0; }
`

const WaveFlex = styled(coloredFlex)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  animation: ${progressAnimation};
  animation-iteration-count: infinite;
  animation-duration: 1s;
  animation-timing-function: cubic-bezier(0.4, 0, 1, 1);
  background-image: linear-gradient(90deg, transparent, ${containerColor}, transparent);
  opacity: 0.36;
  background-size: 160px 100%;
  background-repeat: no-repeat;
`

export const SkeletonAnimation = props => (
  <CustomizedFlex color={props.color} className={props.className}>
    <ItemsFlex>{props.children}</ItemsFlex>
    <WaveFlex color={props.color} />
  </CustomizedFlex>
)

SkeletonAnimation.propTypes = {
  color: PropTypes.string,
}

SkeletonAnimation.defaultProps = {
  color: 'var(--color-neutral-70)',
}
